import {
    RENTAL_OPERATOR_PUBLISH_REVIEW_SUCCESS,
    RENTAL_OPERATOR_PUBLISH_REVIEW_ERROR,
    RENTAL_OPERATOR_PUBLISH_REVIEW_START,
    RENTAL_OPERATOR_DECLINED_SUCCESS,
    RENTAL_OPERATOR_DECLINED_ERROR,
    RENTAL_OPERATOR_DECLINED_START
} from '../Constants/RentalOperatorReviewConstant'
const initialState = {
    loading: false,
    publishReviewData: [],
    declineReviewData: [],
};
export default function RentalOperatorReviewReducer(state = { ...initialState }, action) {
    switch (action.type) {
        case RENTAL_OPERATOR_PUBLISH_REVIEW_START:
            return {
                ...state,
                loading: true,
            };
        case RENTAL_OPERATOR_PUBLISH_REVIEW_SUCCESS:
            return {
                ...state,
                publishReviewData: action.payload,
                loading: false,
            };
        case RENTAL_OPERATOR_PUBLISH_REVIEW_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        case RENTAL_OPERATOR_DECLINED_START:
            return {
                ...state,
                loading: true,
            };
        case RENTAL_OPERATOR_DECLINED_SUCCESS:
            return {
                ...state,
                declineReviewData: action.payload,
                loading: false,
            };
        case RENTAL_OPERATOR_DECLINED_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        default:
            return state;
    }
}

